export default (params) => {
  const checklistType =
    !params.data &&
    params.node.childrenAfterGroup &&
    params.node.childrenAfterGroup.length > 0
      ? params.node.childrenAfterGroup[0].data['checklistType']
      : null;
  const reitTypeDescription =
    !params.data &&
    params.node.childrenAfterGroup &&
    params.node.childrenAfterGroup.length > 0
      ? params.node.childrenAfterGroup[0].data['reitTypeDescription']
      : null;
  const propertyTypeDescription =
    !params.data &&
    params.node.childrenAfterGroup &&
    params.node.childrenAfterGroup.length > 0
      ? params.node.childrenAfterGroup[0].data['propertyTypeDescription']
      : null;
  return checklistType && checklistType.toLowerCase() == 'psq'
    ? propertyTypeDescription
    : checklistType &&
        checklistType.toLowerCase() == 'arqc' &&
        reitTypeDescription;
};
